var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWall2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 616.41 775.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9aadca;}.cls-2{fill:#6479a6;}.cls-3{fill:#788bb2;}.cls-4{fill:#8a9bbf;}.cls-5{fill:#94a5ca;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fyldning_Inspektion",
    "data-name": "Fyldning & Inspektion"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "327.14 419.87 340.37 415.51 340.37 271.51 327.07 263.83 327.14 419.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "596.46 575.37 593.14 354.45 0 12 0 231 327.14 419.87 327.07 263.83 393.57 302.23 393.57 458.23 596.46 575.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 775.17 616.41 574.88 613.09 353.96 0 553.17 0 775.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 0 0 12 586.49 350.61 0 541.17 0 553.17 613.09 353.96 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M372.29,509.85,133,588.17a4,4,0,0,0-2.76,3.8v143.5a4,4,0,0,0,8,0V594.88l234.09-76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M585.16,540.24l-28,9.1v-67l-8,1.32V599.35a4,4,0,0,0,8,0V557.76l30.49-9.91a4,4,0,0,0-2.47-7.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M412.19,454.88l-265.93,87a4,4,0,0,0,1.24,7.8,4.11,4.11,0,0,0,1.24-.19l263.45-85.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.27,560l-6-.48L0,595.4v8.41L110.25,568v45.59L0,649.4v8.41L110.25,622V742a4,4,0,0,0,8,0l.63-177Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWall2);
export default __webpack_public_path__ + "static/media/wall-2.42f7a78bb6bf8d5de8d0c86910c54fbc.svg";
export { ForwardRef as ReactComponent };